<script setup>
// import i18n from "@/i18n"
import { ref, onMounted, provide } from "vue"
// import formCom1 from "./components/form1.vue" // 表单信息1
// import formCom2 from "./components/form2.vue" //表单信息2
import accountInfoCom from "./components/accountInfo.vue" //表单信息2
import { showMessage } from "@/utils/hooks/message"
import { getBusinessInfoDetail } from "@/service/index"
import completeSvg from "@/assets/images/login/complete.svg"
import infoSvg from "@/assets/images/account/info.svg"
import { useRouter } from "vue-router"
import { getLangValue } from "@/utils/common"; //获取后端语言
const PageHeaderT = getLangValue("my.account","title")
const PageHeaderItems = [
    // {
    //     text: i18n.global.t("menu.my"),
    //     active: false,
    // },
    {
        text:getLangValue("my.account","title"),
        active: true,
    },
]
// const formData = ref({})
const showIndex = ref(4)  // 0-未添加信息  1-表单信息  2-审核中信息  3-审核失败信息  4-审核成功 展示自己的信息
const showBarIndex = ref(0)
const detailInfo = ref({})
const router = useRouter()
provide('detailInfo', detailInfo)
// const nextStep = async (formData1) => {
//     if (showBarIndex.value == 0) {
//         formData.value = formData1
//         showBarIndex.value++
//     } else if (showBarIndex.value == 1) {
//         // 提交信息
//         // console.log(formData1);
//         // console.log(formData.value);
//         let params = {
//             company_name: formData.value.companyNmae, //公司名称
//             company_logo: formData1[0].logo.map(item => item.id)[0],
//             company_type: formData.value.companyType, // 企业类型
//             contact_first_name: formData.value.xing, //联系人姓
//             contact_last_name: formData.value.name, // 联系人名
//             contact_email: formData.value.email, // 联系人邮箱
//             landline_number: formData.value.phone, // 座机号码
//             mobile_phone_number: formData.value.phone_number, // 手机号码
//             certification_company: formData.value.is_certification_company, // 是否第三方认证公司
//             testing_company: formData.value.testing_company, // 是否检测机构
//             business_scope: formData.value.main_business_areas, //经营范围
//             place_of_incorporation: formData1[0].Enterprise_registered_countryKey, //公司注册地
//             certificate_number: formData1[0].Certificate_No, //证书编号
//             company_qualification: formData1[0].qualification_documents.map(item => item.id), //公司资质
//             // Enterprise_registered_country: formData1[0].Enterprise_registered_country, // 企业注册地址国家
//             landline_number_area: formData.value.phoneCountry, // 联系人座机 国家
//             mobile_phone_number_area: formData.value.phone_numberCountry, // 联系人手机国家
//             company_address: formData1[1].map(item => {
//                 return {
//                     name: item.country, //简称
//                     country: item.countryKey, //国家
//                     province: item.province, //省
//                     city: item.city, //市
//                     address1: item.address, //详情地址1
//                     address2: '', //详情地址2
//                     address3: '', //详情地址3
//                     postcode: item.post, //邮编
//                 }
//             }), // 生产地址
//         }
//         // console.log(params);
//         let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
//         let x = true
//         if (x) {
//             const resp = await perfect_information(user_id, params);
//             if (resp) {
//                 if (resp.code == 0) {
//                     showMessage('success', resp.message)
//                     // showBarIndex.value++
//                     // showIndex.value = 2
//                     //查询详情状态
//                     getStatusFun()
//                 } else {
//                     showMessage('danger', resp.message)
//                 }
//             }
//         }
//     }

// }
// const backStep = () => {
//     if (showBarIndex.value > 0) {
//         showBarIndex.value--
//     }
// }

const updateDetailInfo =()=> {
    // 更新信息
    getStatusFun();
}

const getStatusFun = async () => {
    // 是否有数据在审核  有的话就在第三步   没有的话就在默认的第一步  失败的话在第4步  第4步可以重新提交信息
    // let status = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).status : ''
    // 0-未审核-待完善资料  1-审核通过  2待审核-已完善资料  3待审核-更新除联系人/手机号码/公司邮箱/联系人邮箱/座机号码 4审核完善资料-未通过  5 审核更新资料-未通过
    // console.log(status);
    let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
    if (user_id === '' || typeof user_id == 'undefined') {
        showMessage('danger', getLangValue("base.request403"))
        router.push({ path: '/login' })
    } else {
        const resp = await getBusinessInfoDetail(user_id);
        detailInfo.value = resp.payload
        let status = '' //设置状态
        if (resp && resp.payload && resp.payload.status) {
            status = resp.payload.status
        } else {
            status = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).status : ''
        }
        // 显示数据
        if (status == 0) {
            showIndex.value = 0
        } else if (status == 1) {
            showIndex.value = 4
        } else if (status == 2) {
            showIndex.value = 2
        } else if (status == 4) {
            showIndex.value = 3
        } else {
            showIndex.value = 4
        }
    }
}

const goComplete = async () => {
    // 获取详细信息
    let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
    const resp = await getBusinessInfoDetail(user_id);
    if (resp) {
        detailInfo.value = resp.payload
        // let imgIdStr = currendData.value.company_qualification.join(',')
        // if (imgIdStr)
        //     getFileUrl({ attachments: imgIdStr }).then(resp => {
        //         if (resp) {
        //             srcList.value = resp.payload
        //         }
        //     })
        // let imgIdStr1 = currendData.value.company_logo
        // if (imgIdStr1)
        //     getFileUrl({ attachments: imgIdStr1 }).then(resp => {
        //         if (resp) {
        //             srcList1.value = resp.payload
        //             // formData.value.logo = resp.payload
        //         }
        //     })
        showIndex.value = 1
    }
}
onMounted(() => {
    // 初始状态
    getStatusFun();
    // detailInfo.value =
    // {
    //     "company_name": "金科组数",
    //     "company_type": "生产商",
    //     "contact_first_name": "feng",
    //     "contact_last_name": "tao",
    //     "contact_email": "11107949255@qq.com",
    //     "landline_number": "2659866",
    //     "mobile_phone_number": "15108343658",
    //     "certification_company": true,
    //     "business_scope": "服装数据库,纱线数据库",
    //     "place_of_incorporation": "dwq ",
    //     "certificate_number": "dwq131",
    //     "company_qualification": [
    //         "66988197b9fc9a463208f059"
    //     ],
    //     "logo": [
    //         "66988197b9fc9a463208f059"
    //     ],
    //     "Enterprise_registered_country": "阿富汗",
    //     "phoneCountry": "阿富汗",
    //     "phone_numberCountry": "安哥拉",
    //     "company_address": [
    //         {
    //             "name": "AF",
    //             "country": "阿富汗",
    //             "province": "11",
    //             "city": "11",
    //             "address1": "1",
    //             "address2": "",
    //             "address3": "",
    //             "postcode": "1"
    //         },
    //         {
    //             "name": "AF",
    //             "country": "阿富汗",
    //             "province": "1",
    //             "city": "11",
    //             "address1": "1",
    //             "address2": "",
    //             "address3": "",
    //             "postcode": "1"
    //         }
    //     ]
    // }
})
</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 160px);">
            <div class="w-100 h-100 bg-white" v-show="showIndex == 0">
                <div class="d-flex align-items-center justify-content-center h-100"
                    style="font-size: 16px; flex-direction: column;">
                    {{ getLangValue("my.account", 'info') }}
                    <div style="text-align: center;color: #0AB39C;text-decoration:underline">
                        <span class="p-1 cursor-pointer" @click="showIndex = 1">{{ getLangValue("my.account", 'info1') }}</span>
                    </div>
                </div>
            </div>
            <div class="w-100 h-100 bg-white py-8" v-show="showIndex == 1" style="overflow-y: auto;">
                <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                    <div style="width: 958px; height: 750px;">
                        <div class="progressbar d-flex align-items-center" style="height: 58px;">
                            <div class="flex-1 d-flex align-items-center">
                                <div class="d-flex align-items-center justify-content-center"
                                    style="width: 40px; height: 40px; background-color: #9599AD; border-radius: 50%;">
                                    <i style="font-size: 24px; color: white;" class=" ri-arrow-left-s-line"></i>
                                </div>
                                <hr
                                    style="width: calc(100% - 40px); border: 2px solid #212529 !important; opacity: 1;" />
                            </div>
                            <div class="flex-1" style="position: relative;">
                                <div>
                                    <div class="d-flex align-items-center" style="height: 40px;">
                                        <div class="d-flex align-items-center justify-content-center"
                                            style="width: 40px; height: 40px; ">
                                            <div :class="showBarIndex == 0 ? 'active' : ''"
                                                style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                                1
                                            </div>
                                            <div
                                                style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                                {{ getLangValue("my.account", 'progressInfo1') }}</div>
                                        </div>
                                        <hr
                                            style="width: calc(100% - 40px); border: 2px solid #212529 !important; opacity: 1;" />
                                    </div>
                                </div>

                            </div>
                            <div class="flex-1" style="position: relative;">
                                <div>
                                    <div class="d-flex align-items-center" style="height: 40px;">
                                        <div class="d-flex align-items-center justify-content-center"
                                            style="width: 40px; height: 40px; ">
                                            <div :class="showBarIndex == 1 ? 'active' : ''"
                                                style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                                2
                                            </div>
                                            <div
                                                style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                                {{ getLangValue("my.account", 'progressInfo2') }}</div>
                                        </div>
                                        <hr
                                            style="width: calc(100% - 40px); border: 2px solid #212529 !important; opacity: 1;" />
                                    </div>
                                </div>
                            </div>
                            <div class="flex-1" style="position: relative;">
                                <div>
                                    <div class="d-flex align-items-center" style="height: 40px;">
                                        <div class="d-flex align-items-center justify-content-center"
                                            style="width: 40px; height: 40px; ">
                                            <div :class="showBarIndex == 2 ? 'active' : ''"
                                                style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                                3
                                            </div>
                                            <div
                                                style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                                {{ getLangValue("my.account", 'progressInfo3') }}</div>
                                        </div>
                                        <hr
                                            style="width: calc(100% - 40px); border: 2px solid #212529 !important; opacity: 1;" />
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="d-flex align-items-center justify-content-center"
                                    style="width: 40px; height: 40px; background-color: #9599AD; border-radius: 50%;">
                                    <i style="font-size: 24px; color: white;" class=" ri-arrow-right-s-line"></i>
                                </div>
                            </div>
                        </div>
                        <!-- 表单部分 -->
                        <!-- <formCom1 @nextStep="nextStep" v-show="showBarIndex == 0" />
                        <formCom2 @nextStep="nextStep" v-show="showBarIndex == 1" @backStep="backStep" /> -->
                    </div>
                </div>
            </div>
            <div class="w-100 h-100 bg-white py-8" v-show="showIndex == 2" style="overflow-y: auto;">
                <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                    <div style="width: 958px; height: 750px;">
                        <div class="d-flex align-items-center justify-content-center"
                            style="height: calc(100% - 58px);">
                            <div>
                                <div class="mb-3 " style="width: 96px; margin: 90px auto;">
                                    <img :src="completeSvg" width="96" />
                                </div>
                                <div style="text-align: center; margin: 20px 0 180px 0;">
                                    {{ getLangValue("my.account", 'progressInfo4') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100 h-100 bg-white py-8" v-show="showIndex == 3" style="overflow-y: auto;">
                <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                    <div style="width: 958px; height: 750px;">
                        <div class="d-flex align-items-center justify-content-center"
                            style="height: calc(100% - 58px);">
                            <div>
                                <div class="mb-3 " style="width: 96px; margin: 0px auto;">
                                    <img :src="infoSvg" width="96" />
                                </div>
                                <div style="text-align: center; margin: 20px 0 60px 0;">
                                    {{ getLangValue("my.account", 'progressInfo5') }}
                                </div>
                                <div style="text-align: center; margin: 20px 0 0px 0;">
                                    <b-button class="mx-2" variant="success" @click="goComplete"
                                        style="width: 104px;height: 38px;">
                                        {{ getLangValue("my.account", 'btn_complete') }}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 展示信息 -->
            <div class="w-100 h-100  py-8 my-scroll-bar" v-show="showIndex == 4" >
                <accountInfoCom @updateDetailInfo="updateDetailInfo" />
            </div>
        </div>
    </Layout>
</template>
<style scoped>
.active {
    background-color: #0AB39C !important;
}

.form-control {
    color: #888a97;
}
</style>